import React, { useEffect, useState } from "react";

import { Box, Progress, Text } from "@noom/wax-component-library";

type ProgressBarProps = {
  onComplete?: () => void;
  totalTimeMs: number;
  borderRadius?: string;
  height?: string;
  trackColor?: string;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({
  onComplete,
  totalTimeMs,
  trackColor,
  borderRadius = "0",
  height = "48px",
}) => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(
      () =>
        setPercentage((percent) => {
          if (percent === 100) {
            clearInterval(intervalId);
            return percent;
          }
          return percent + 1;
        }),
      totalTimeMs / 100,
    );

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (percentage === 100) {
      onComplete?.();
    }
  }, [percentage]);

  return (
    <Box>
      <Box position="relative">
        <Progress
          colorScheme="primary"
          height={height}
          size="lg"
          value={percentage}
          width="300px"
          borderRadius={borderRadius}
          backgroundColor={trackColor}
        />
        <Text
          bottom="50%"
          fontWeight={500}
          left="50%"
          position="absolute"
          transform="translateX(-50%) translateY(50%)"
        >
          {percentage}%
        </Text>
      </Box>
    </Box>
  );
};
